module.exports = {"Page2::deposit":"Reservationszahlung","Page2::deposit_title":"Reservationszahlung"}


//////////////////
// WEBPACK FOOTER
// ./src/app/@propnow/locales/de-CH.json
// module id = 446
// module chunks = 260